<template lang="pug">
  .rotation
    .rotation__item(v-for="item in items", :class="'rotation__item_' + item.mod")
      .rotation__item-text(v-html="item.text")
      .rotation__item-icon
</template>

<script>
export default {
  name: 'Rotation',
  data() {
    return {
      items: [
        {
          mod: 'tablet',
          text: 'Please turn the&nbsp;device into&nbsp;horizontal&nbsp;mode',
        },
        {
          mod: 'mobile',
          text: 'Please turn the&nbsp;device into&nbsp;portrait&nbsp;mode',
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
  .rotation {
    @include vertical-align;
    justify-content: center;
    z-index: z('modal');
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($clr-darkBlue, .95);
    display: none;
    @media (-moz-touch-enabled: 1),
      (pointer: coarse) {
      @media (min-width: $min-width-sm)
        and (max-width: $max-width-sm)
        and (orientation: portrait),
        (max-width: $max-width-mobile)
        and (orientation: landscape) {
        display: flex;
      }
    }
    &__item {
      text-align: center;
      padding: 0 $gutter-width;
      margin-top: -50px;
      display: none;
      @media (max-width: $max-width-mobile) {
        margin-top: -20px;
      }
      &_tablet {
        @media (min-width: $min-width-sm)
          and (max-width: $max-width-sm)
          and (orientation: portrait) {
          display: block;
        }
      }
      &_mobile {
        @media (max-width: $max-width-mobile)
          and (orientation: landscape) {
          display: block;
        }
      }
      &_tablet & {
        &-icon {
          @include retina-sprite($rotation-icon-tablet-group);
        }
      }
      &_mobile & {
        &-icon {
          @include retina-sprite($rotation-icon-mobile-group);
        }
      }
      &-icon {
        margin: 0 auto;
      }
      &-text {
        @include typo-h1;
        color: $clr-main;
        margin: 0 0 50px;
        max-width: 500px;
        @media (max-width: $max-width-xs) {
          margin: 0 0 30px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UI/Rotation.vue